import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
// 招商银行页面路由
var cmbAppShowHome = function cmbAppShowHome() {
  return import('@/pages/cmbApp/index.vue');
};
export default [{
  //  cmbapp ==> 招商银行app 演出内嵌
  path: '/cmbApp',
  component: cmbAppShowHome,
  children: [{
    // 演出授权页
    path: 'auth*',
    name: 'cmbAppAuth',
    component: function component() {
      return import('@/pages/cmbApp/auth.vue');
    }
  }]
}];